import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  click(event) {
    event.preventDefault()
    if (this.element.classList.contains('disabled')) return

    const icon = this.element.querySelector('i')
    icon.className = 'spinner-border spinner-border-sm me-1'
    icon.setAttribute('role', 'status')
    this.element.classList.add('disabled')
    this.element.setAttribute('aria-disabled', 'true')
    this.element.setAttribute('aria-busy', 'true')
    this.element.setAttribute('tabindex', '-1')

    // redirect: 'error' rejects instead of following. Without it a vanished session's
    // 302 is followed to a 200 sign-in page, which satisfies response.ok and gets saved
    // to disk as download.pdf.
    fetch(this.element.href, { redirect: 'error' })
      .then((response) => {
        const contentType = response.headers.get('content-type') || ''
        if (!response.ok || !contentType.startsWith('application/pdf')) {
          throw new Error('Download failed')
        }
        const filename = response.headers
          .get('content-disposition')
          ?.match(/filename[*]?=(?:UTF-8''|"?)([^";]+)"?/)?.[1] || 'download.pdf'
        return response.blob().then((blob) => ({ blob, filename }))
      })
      .then(({ blob, filename }) => {
        const url = URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        a.download = decodeURIComponent(filename)
        a.click()
        URL.revokeObjectURL(url)
      })
      .catch(() => {
        window.location = this.element.href
      })
      .finally(() => {
        icon.className = 'bi bi-download me-1'
        icon.removeAttribute('role')
        this.element.classList.remove('disabled')
        this.element.removeAttribute('aria-disabled')
        this.element.removeAttribute('aria-busy')
        this.element.removeAttribute('tabindex')
      })
  }
}
